// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1O90N","author":"Table_author__1bdjh","authorImage":"Table_authorImage__3xZlL","unreadRow":"Table_unreadRow__3Wuki"};